module.exports = __webpack_public_path__ + "img/icon_map_32_on_110.9961e862.png";